import { Component } from '@angular/core';

@Component({
  selector: 'app-outing-link',
  templateUrl: './outing-link.component.html',
  styleUrls: ['./outing-link.component.scss']
})
export class OutingLinkComponent {

}
